export default "__VITE_ASSET__DdsNi4CU__"